import React from "react";
import { Grid, Typography, Paper, Divider } from "@material-ui/core";

import addProduct from "../../../../assets/images/ProductIllustration.svg";
import useStyles from "./styles";
import AddProductCard from "../../../AddProductCard/AddProductCard";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import AddCircleOutline from "@material-ui/icons/AddCircleOutline";

export default function AddProductCards() {
  const classes = useStyles();
  return (
    <Grid container component={Paper}>
      <Grid item xs={12} sm={12} md={12}>
        <div className={classes.paper}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <Typography variant="h4" gutterBottom>
                Add Product Details
              </Typography>
              <Divider />
            </Grid>
            <Grid
              container
              spacing={2}
              justify="space-between"
              style={{ marginBottom: 16 }}
            >
              <Grid item xs={12} md={3} style={{ marginTop: 55 }}>
                <AddProductCard
                  link="/admin/add-product-vendor"
                  title="Add Product (Vendor)"
                  icon={<AddCircleOutline style={{ fontSize: 55 }} />}
                />
              </Grid>

              <Grid item xs={12} md={3} style={{ marginTop: 55 }}>
                <AddProductCard
                  link="/admin/add-product-store"
                  title="Add Product (Store)"
                  icon={<AddShoppingCartIcon style={{ fontSize: 50 }} />}
                />
              </Grid>
              <Grid item xs={false} sm={false} md={6} lg={4}>
                <div
                  style={{
                    border: "1px solid rgb(224 224 224)",
                    borderRadius: 6,
                    padding: 15,
                    marginBottom: 10,
                  }}
                >
                  <img
                    src={addProduct}
                    alt="product"
                    style={{
                      maxWidth: "300px",
                      marginBottom: 20,
                    }}
                  />
                  <Typography variant="h5">DO YOU KNOW?</Typography>
                  <Typography variant="body2" style={{ textAlign: "justify" }}>
                    In order to make more sales, Write an eye-catching and short
                    name for Product and upload its high-quality images.
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div>
        {/* </Container> */}
      </Grid>
    </Grid>
  );
}
